(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const ringBases = [120, 220, 340, 480, 640];
  const sections = new Set();
  const stickyCtas = new Set();
  let frame = 0;

  const updateSection = (section) => {
    if (!section.isConnected) {
      sections.delete(section);
      return;
    }

    const rect = section.getBoundingClientRect();
    const viewport = window.innerHeight || 1;
    if (rect.bottom < -120 || rect.top > viewport + 120) return;

    const progress = reducedMotion.matches
      ? 1
      : (() => {
          const raw = 1 - (rect.top + rect.height / 2) / (viewport + rect.height / 2);
          return Math.max(0, Math.min(1, raw));
        })();

    section.style.setProperty('--naru-scent-t', progress.toFixed(4));
    section.style.setProperty('--naru-scent-back-y', `${((1 - progress) * 30).toFixed(2)}px`);
    section.style.setProperty('--naru-scent-front-y', `${((1 - progress) * 60).toFixed(2)}px`);
    section.style.setProperty('--naru-scent-watermark-y', `${((progress - 0.5) * 30).toFixed(2)}px`);
    section.style.setProperty('--naru-scent-note-opacity', (0.4 + progress * 0.6).toFixed(4));
    section.querySelectorAll('.naru-scent__note').forEach((note, index) => {
      const shift = 12 + index * 6;
      note.style.setProperty('--naru-scent-note-y', `${((1 - progress) * shift).toFixed(2)}px`);
    });
    section.querySelectorAll('.naru-scent__rings circle').forEach((circle, index) => {
      const base = ringBases[index];
      if (base) circle.setAttribute('r', String(base + progress * 30));
    });
  };

  const update = () => {
    frame = 0;
    sections.forEach(updateSection);
    const footer = document.querySelector('.naru-footer');
    const footerRect = footer?.getBoundingClientRect();
    document.body.classList.toggle(
      'naru-home-footer-visible',
      Boolean(footerRect && footerRect.top < window.innerHeight && footerRect.bottom > 0)
    );
    stickyCtas.forEach((cta) => {
      if (!cta.isConnected) {
        stickyCtas.delete(cta);
        return;
      }
      const promptSection = document.querySelector('.section-naru-cost');
      const promptRect = promptSection?.getBoundingClientRect();
      const visible = Boolean(
        promptRect
        && promptRect.top < window.innerHeight * 0.2
        && promptRect.bottom > window.innerHeight * 0.7
      );
      cta.classList.toggle('is-visible', visible);
    });
  };

  const requestUpdate = () => {
    if (!frame) frame = window.requestAnimationFrame(update);
  };

  const register = (root = document) => {
    root.querySelectorAll('[data-naru-scent]').forEach((section) => sections.add(section));
    root.querySelectorAll('[data-naru-sticky-cta]').forEach((cta) => {
      cta.hidden = false;
      cta.classList.add('is-ready');
      stickyCtas.add(cta);
    });
    requestUpdate();
  };

  register();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  reducedMotion.addEventListener?.('change', requestUpdate);
  document.addEventListener('shopify:section:load', (event) => register(event.target));
  document.addEventListener('shopify:section:unload', requestUpdate);
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-naru-scroll-target]');
    if (!trigger) return;
    const target = document.getElementById(trigger.dataset.naruScrollTarget);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
  });
})();
